'use client';
var classes = {"root":"m-4addd315","control":"m-326d024a","dots":"m-4ad7767d"};

export default classes;
//# sourceMappingURL=Pagination.module.mjs.map
